import "./style.css";
import { ArrowBack } from "@mui/icons-material";
import React, { useState, useMemo, useEffect, useCallback } from "react";
import { Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { PiCurrencyCircleDollar } from "react-icons/pi";
import { MdCurrencyRupee } from "react-icons/md";
import { HiOutlineDocumentCurrencyRupee } from "react-icons/hi2";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import ButtonCom from "../../../../components/button/button";
import { LiaRupeeSignSolid } from "react-icons/lia";
import CustomPagination from "../../../../components/CustomPagination";
import Modal from "react-bootstrap/Modal";

import { TfiMenuAlt } from "react-icons/tfi";
import { LiaHandHoldingUsdSolid } from "react-icons/lia";
import ReplayIcon from "@mui/icons-material/Replay";
import { IoDiamondOutline } from "react-icons/io5";
import { LuTimerReset } from "react-icons/lu";
import { RxTimer } from "react-icons/rx";
import { RxCross2 } from "react-icons/rx";
import { CiWallet } from "react-icons/ci";
import { Link, useLocation } from "react-router-dom";
// 
import { useGlobalToast } from "../../../../stopOldToastGlobally";

import Widgets from "../../../../components/Widgets/index";

// Functions -------------------
import {
  getFormattedToday,
  getCapitalizeWord,
  getFormattedDate,
  getInitials,
  getInitialColor,
  getMonth,
  getCurrentDate,
  getFormattedUsers,
  getEmployeeFormattedDataOne,
  downloadCSV,
} from "../../../../services/commonServices";

import {
  addWorkBasicPayPath,
  addIncentiveStaffPath,
  addReimbursementStaffPath,
  addBonusWagePath,
  addOtherEarningsPath,
  addOtherDeductionsPath,
  getWorkBasicPayPath,
  getIncentivePath,
  getReimbursementPath,
  getBonusWagePath,
  getOtherEarningsPath,
  getOtherDeductionsPath,
  getPaymentHistoryPath,
  addAdvancePath,
  calculateEarnedSalaryPath,
  overtimePaySettingsPath,
  earlyFineSettingsPath,
  lateFineSettingsPath,
  getOvertimePayDetailsPath,
  getEarlyFineDetailsPath,
  getLateFineDetailsPath,
  saveFinalizePayrollPath,
  saveOfflinePaymentPath,
  savePaymentHistoryPath,
} from "../../../../services/config";

import {
  commonGetData,
  commonSaveData,
  initCommonState,
} from "../../../../redux/slices/commonSlice";
import {
  saveAttendance,
  initAttendanceState,
} from "../../../../redux/slices/attendanceSlice";
import {
  fetchPaymentHistoryData,
  savePaymentHistory,
  calculateSalary,
  initPaymentState,
} from "../../../../redux/slices/paymentHistory";
import { useDispatch, useSelector } from "react-redux";
import { dateCalendarClasses } from "@mui/x-date-pickers";

import { HasPermission } from "../../../../services/hasPermission";

// Constant variables ---------------------------------
const paginationPageSize = 100;
const paginationPageSizeSelector = [10, 20, 50, 100];
// ----------------------------------------------------

const RunPayroll = () => {
  const customToast = useGlobalToast();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const dispatch = useDispatch();
  const commonStore = useSelector((state) => state.common);
  const attendanceStore = useSelector((state) => state.attendance);
  const paymentStore = useSelector((state) => state.paymentHistory);

  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("user");
  const staffName = queryParams.get("staffName");
  const staffId = queryParams.get("staffId");
  const month = queryParams.get("month");
  const [payment, setPayment] = useState("");

  const today = new Date().toISOString().split("T")[0];
  const today_ = new Date();
  const year = today_.getFullYear();
  const month_ = (today_.getMonth() + 1).toString().padStart(2, "0"); // getMonth() is 0-indexed

  const maxMonth = `${year}-${month_}`; // YYYY-MM

  const [runPayrollList, setRunPayrollList] = useState([
    {
      month: month,
      payrollFinalized: "Yes",
      ctc: "25550/per month",
      payable: "25550",
      totalSalary: "25550",
      paid: "yes",
      pending: "no",
      slipShared: "Yes",
    },
  ]);

  const [state, setState] = useState({
    userId: user.user_id,
    staffId: staffId,
    selectedDate: "",
  });

  const [paymentSummary, setPaymentSummary] = useState({});
  const [staffDetails, setStaffDetails] = useState([]);

  const [salarySummary, setSalarySummary] = useState({});
  const [paymentList, setPaymentList] = useState([]);
  const [attendanceList, setAttendanceList] = useState([]);

  const [isActive, setIsActive] = useState(false);
  const [isFirstView, setIsFirstView] = useState(true);

  const [workBasisValidated, setWorkBasisValidated] = useState(false);
  const [isWorkBasisPay, setIsWorkBasisPay] = useState(false);

  const [isIncentives, setIsIncentives] = useState(false);

  const [isReimbursement, setIsReimbursement] = useState(false);

  const [isBonusWage, setIsBonusWage] = useState(false);

  const [isOvertimePay, setIsOvertimePay] = useState(false);

  const [isOtherEarning, setIsOtherEarning] = useState(false);

  const [isEarlyFine, setIsEarlyFine] = useState(false);

  const [isLateFine, setIsLateFine] = useState(false);

  const [isDeductions, setIsDeductions] = useState(false);

  const [isLoans, setIsLoans] = useState(false);

  const [addCtc, setAddCtc] = useState({});
  const [addAllowance, setAddAllowance] = useState([]);
  const [addNewAllowance, setAddNewAllowance] = useState([]);
  const [isActiveCtc, setIsActiveCtc] = useState(false);
  const [finalize, setFinalize] = useState(false);
  const [isSaveSalary, setIsSaveSalary] = useState(false);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handleGetCtc = (data) => {
    if (data.basicPay) {
      setAddCtc(data);
    }

    const allowanceArr = data.allowanceList?.filter(
      (item) => item.name != "Other Allowance"
    );
    setAddAllowance(allowanceArr);

    const newAllowanceArr = data.newAllowanceList?.filter(
      (item) => item.name != "Other Allowance"
    );
    setAddNewAllowance(newAllowanceArr);
    setIsActiveCtc(true);
  };

  const columns = useMemo(
    () => [
      {
        headerName: "Month",
        field: "payrollMonthYear",
        filter: true,
      },
      {
        headerName: "Payroll Finalized",
        cellRenderer: (rowData) => {
          return rowData.data.finalizedPayroll == "0" ? "No" : "Yes";
        },
        filter: true,
      },
      {
        headerName: "CTC",
        cellRenderer: (rowData) => {
          return (
            <div
              onClick={() => handleGetCtc(rowData.data)}
              style={{ cursor: "pointer" }}
            >
              {parseFloat(rowData.data.costToCompany).toFixed(2)}
            </div>
          );
        },
        filter: true,
      },
      {
        headerName: "Payable ",
        cellRenderer: (rowData) => {
          return rowData.data.payableDays ? rowData.data.payableDays : "-";
        },
        filter: true,
      },
      {
        headerName: "Total Salary",
        cellRenderer: (rowData) => {
          return rowData.data.netSalary ? rowData.data.netSalary : "-";
        },
        filter: true,
      },
      {
        headerName: "Paid",
        cellRenderer: (rowData) => {
          return rowData.data.paid ? rowData.data.paid : "-";
        },
        filter: true,
      },
      {
        headerName: "Pending",
        cellRenderer: (rowData) => {
          return rowData.data.paid
            ? parseFloat(rowData.data.costToCompany).toFixed(2) -
            parseFloat(rowData.data.paid).toFixed(2)
            : "-";
        },
        filter: true,
      },
      // {
      //   headerName: "Slip Shared",
      //  cellRenderer: (rowData) => {
      //     return rowData.data.paid ? rowData.data.paid : "-";
      //   },
      //   filter: true,
      // },
    ],
    []
  );
  // Functions ---------------------------

  const getIndividualPaymentHistory = (date) => {
    const data = {
      path: getPaymentHistoryPath,
      data: {
        userId: state.userId,
        staffId: state.staffId,
        // selectedDate: date + "-01",
      },
    };
    const d = {
      path: calculateEarnedSalaryPath,
      data: {
        userId: state.userId,
        staffId: state.staffId,
        selectedDate: date + "-01",
      },
    };
    dispatch(savePaymentHistory(data));
    dispatch(calculateSalary(d));
  };

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      selectedDate: `${year}-${month_}`,
    }));

    getIndividualPaymentHistory(`${year}-${month_}`);
  }, []);

  // useEffect(() => {
  //   getIndividualPaymentHistory(state.selectedDate);
  // }, [state.selectedDate]);

  const handleDate = ({ target: { name, value } }) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));

    const data = {
      path: savePaymentHistoryPath,
      data: {
        userId: user.user_id,
        selectedDate: `${value}-01`,
        branchId: "",
        shiftId: "",
        staffId: "",
      },
    };
    console.log(data);
    dispatch(commonSaveData(data));

    getIndividualPaymentHistory(value);
  };

  const getAttendanceList = (path) => {
    const data = {
      path: path,
      data: {
        userId,
        staffId,
        paymentDate: "",
      },
    };
    dispatch(saveAttendance(data));
  };

  const getDifferentTypeData = (type) => {
    let path = null;
    if (type != undefined) {
      if (type == "overtimePay") {
        path = getOvertimePayDetailsPath;
      }
      if (type == "latPay") {
        path = getLateFineDetailsPath;
      }
      if (type == "earlyPay") {
        path = getEarlyFineDetailsPath;
      }
    } else {
      if (isOvertimePay) {
        path = getOvertimePayDetailsPath;
      } else if (isLateFine) {
        path = getLateFineDetailsPath;
      } else {
        path = getEarlyFineDetailsPath;
      }
    }
    const data = {
      path: path,
      data: {
        userId: user.user_id,
        staffId,
      },
    };

    dispatch(fetchPaymentHistoryData(data));
  };

  const toggleAddDetails = (type) => {
    if (isActive) {
      setAttendanceList([]);
      setIsActive(false);
      setIsWorkBasisPay(false);
      setIsIncentives(false);
      setIsReimbursement(false);
      setIsBonusWage(false);
      setIsOvertimePay(false);
      setIsOtherEarning(false);
      setIsEarlyFine(false);
      setIsLateFine(false);
      setIsDeductions(false);
      setIsLoans(false);
      setIsFirstView(true);
    } else {
      if (type == "isWorkBasisPay") {
        getAttendanceList(getWorkBasicPayPath);
        setIsWorkBasisPay(true);
      }
      if (type == "isIncentives") {
        getAttendanceList(getIncentivePath);
        setIsIncentives(true);
      }
      if (type == "isReimbursement") {
        getAttendanceList(getReimbursementPath);
        setIsReimbursement(true);
      }
      if (type == "isBonusWage") {
        getAttendanceList(getBonusWagePath);
        setIsBonusWage(true);
      }
      if (type == "isOvertimePay") {
        setIsOvertimePay(true);
        getDifferentTypeData("overtimePay");
      }
      if (type == "isOtherEarning") {
        getAttendanceList(getOtherEarningsPath);
        setIsOtherEarning(true);
      }
      if (type == "isEarlyFine") {
        setIsEarlyFine(true);
        getDifferentTypeData("earlyPay");
      }
      if (type == "isLateFine") {
        setIsLateFine(true);
        getDifferentTypeData("latPay");
      }
      if (type == "isDeductions") {
        getAttendanceList(getOtherDeductionsPath);
        setIsDeductions(true);
      }
      if (type == "isLoans") {
        setIsLoans(true);
      }

      setIsActive(true);
    }
  };

  const hideSecondScreen = () => {
    setIsFirstView(true);
  };
  // Work Basis Pay -----------------------------------------
  const addWorkBasisPay = () => {
    setIsFirstView(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setWorkBasisValidated(true);
      return;
    }

    let path;
    let defaultDateName;

    if (isWorkBasisPay) {
      path = addWorkBasicPayPath;
    } else if (isIncentives) {
      path = addIncentiveStaffPath;
    } else if (isReimbursement) {
      path = addReimbursementStaffPath;
    } else if (isBonusWage) {
      path = addBonusWagePath;
    } else if (isOtherEarning) {
      path = addOtherEarningsPath;
    } else if (isDeductions) {
      path = addOtherDeductionsPath;
    }
    // --------------------------------------------
    if (isIncentives) {
      defaultDateName = "incentiveDate";
    } else if (isReimbursement) {
      defaultDateName = "paymentDate";
    } else {
      defaultDateName = "paymentDate";
    }

    const data = {
      path: path,
      data: {
        userId: user.user_id,
        staffId,
        type: isIncentives ? form["type"].value : "",
        amount: form["amount"].value,
        [defaultDateName]: form["paymentDate"].value,
        notes: form["notes"].value,
      },
    };

    dispatch(commonSaveData(data));
  };

  const saveDifferentTypeData = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;

    const formData = new FormData(form);

    const formFields = {
      ...Object.fromEntries(formData.entries()),
      userId: user.user_id,
      staffId,
    };

    const data = {
      path: isOvertimePay
        ? overtimePaySettingsPath
        : isLateFine
          ? lateFineSettingsPath
          : earlyFineSettingsPath,
      data: formFields,
    };

    dispatch(commonSaveData(data));
  };

  const saveFinalize = () => {
    const data = {
      path: saveFinalizePayrollPath,
      data: {
        userId: user.user_id,
        staffId,
        selectedDate: state.selectedDate + "-01",
        payrollFinalize: "1",
      },
    };
    dispatch(commonSaveData(data));
    setIsFinalizePayroll(false);
  };

  const saveUnFinalize = () => {
    const data = {
      path: saveFinalizePayrollPath,
      data: {
        userId: user.user_id,
        staffId,
        selectedDate: state.selectedDate + "-01",
        payrollFinalize: "0",
      },
    };
    dispatch(commonSaveData(data));
    setSmShow(false);
  };

  useEffect(() => {
    if (commonStore.commonSuccess) {
      getIndividualPaymentHistory(state.selectedDate);
      getDifferentTypeData();
      customToast.success(commonStore.commonMessage);
      dispatch(initCommonState());
      setIsFirstView(true);
      setIsSavePayment(false);

      if (isWorkBasisPay) {
        getAttendanceList(getWorkBasicPayPath);
      }
      // ----------------------------------
      if (isIncentives) {
        getAttendanceList(getIncentivePath);
      }
      // ----------------------------------
      if (isReimbursement) {
        getAttendanceList(getReimbursementPath);
      }
      // ----------------------------------
      if (isBonusWage) {
        getAttendanceList(getBonusWagePath);
      }
      // ----------------------------------
      if (isOtherEarning) {
        getAttendanceList(getOtherEarningsPath);
      }
      // ----------------------------------
      if (isDeductions) {
        getAttendanceList(getOtherDeductionsPath);
      }
    }
    if (commonStore.commonError) {
      customToast.error(commonStore.commonMessage);
      dispatch(initCommonState());
      setIsSavePayment(false);
    }

    if (attendanceStore.attendanceSuccess) {
      setAttendanceList(attendanceStore.attendanceData.data);
      dispatch(initAttendanceState());
    }

    if (paymentStore.salarySuccess) {
      if (
        paymentStore.salaryData.staffDetails[0]?.salaryCountDays
          ?.finalizePayrollStaff == "0"
      ) {
        setFinalize(false);
      } else if (
        paymentStore.salaryData.staffDetails[0]?.salaryCountDays
          ?.finalizePayrollStaff == "1"
      ) {
        setFinalize(true);
      }

      setStaffDetails(paymentStore.salaryData.staffDetails);
      setPaymentSummary(paymentStore.salaryData.summary);
      setPayment(paymentStore.salaryData.summary.OverallCostToCompany);
      dispatch(initPaymentState());
    }

    if (paymentStore.paymentGetSuccess) {
      setSalarySummary(paymentStore.paymentGetData.data);
    }

    if (paymentStore.paymentSuccess) {
      setPaymentList(paymentStore.paymentData);
    }
  }, [commonStore, attendanceStore, paymentStore, dispatch]);

  const [isSavePayment, setIsSavePayment] = useState(false);

  const handleSavePayment = () => {
    setIsSavePayment(!isSavePayment);
  };

  const submitAdvance = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setWorkBasisValidated(true);
      return;
    }
    const data = {
      path: addAdvancePath,
      data: {
        userId: user.user_id,
        staffId,
        amount: form["amount"].value,
        paymentDate: form["paymentDate"].value,
        notes: form["notes"].value,
      },
    };
    dispatch(commonSaveData(data));
  };

  const submitSalary = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setWorkBasisValidated(true);
      return;
    }
    const data = {
      path: saveOfflinePaymentPath,
      data: {
        userId: user.user_id,
        staffId,
        payment: form["amount"].value,
        selectedDate: form["paymentDate"].value,
        // notes: form["notes"].value,
      },
    };
    dispatch(commonSaveData(data));
    setIsSaveSalary(false);
  };

  const [showSalary, setShowSalary] = useState(false);
  const [showAdvance, setShowAdvance] = useState(false);

  const handleShowPaySalary = () => {
    setShowAdvance(false)
    setShowSalary(!showSalary);
  };

  const handleShowAdvance = () => {
    setShowSalary(false)
    setShowAdvance(!showAdvance);
  };

  const hideDropdown = () => {
    if (showSalary) {
      setShowSalary(false)
    }
    if (showAdvance) {
      setShowAdvance(false)
    }
  }

  const [isFinalizePayroll, setIsFinalizePayroll] = useState(false);
  const [smShow, setSmShow] = useState(false);

  const finalPayColumns = useMemo(
    () => [
      {
        headerName: "Employee ID",
        cellRenderer: (rowData) => {
          return (
            <div>
              <span>{rowData.data.employeeId}</span>
              {/* <div className="gray-box"></div> */}
            </div>
          );
        },
        filter: true,
      },
      {
        headerName: "Name",
        cellRenderer: (rowData) => {
          return (
            <div>
              <span>{rowData.data.staffName}</span>
              {/* <div className="orange-box"></div> */}
            </div>
          );
        },
        filter: true,
      },
      {
        headerName: "Worked ON",
        cellRenderer: (rowData) => {
          return (
            <div>
              <span>
                {rowData.data.salaryCountDays.presentDaysCount +
                  rowData.data.salaryCountDays.presentDaysCount +
                  rowData.data.salaryCountDays.halfDayDaysCount}
              </span>
              {/* <div className="green-box"></div> */}
            </div>
          );
        },
        filter: true,
      },
      {
        headerName: "Absent",
        cellRenderer: (rowData) => {
          return (
            <div>
              <span>{rowData.data.salaryCountDays.absentDaysCount} days</span>
            </div>
          );
        },
        filter: true,
      },
      {
        headerName: "Payable",
        cellRenderer: (rowData) => {
          return (
            <div className="">
              <span>
                {rowData.data.salaryCountDays.presentDaysCount +
                  rowData.data.salaryCountDays.presentDaysCount +
                  rowData.data.salaryCountDays.halfDayDaysCount}
              </span>
              <div>
                <div
                  style={{ padding: "20px 0" }}
                  className="mb-2 d-flex flex-column align-items-center justify-center justify-content-center"
                >
                  <h1
                    style={{
                      marginTop: "10px",
                      fontSize: "30px",
                    }}
                    className="color-white"
                  >
                    {rowData.data.CostToCompany}
                  </h1>
                  <span style={{ marginTop: "-40px" }}>Total Amount</span>
                </div>
              </div>
            </div>
          );
        },
        filter: true,
      },
    ],
    []
  );

  const handleFinalize = () => {
    setSmShow(false);
    setIsFinalizePayroll(true);
  };
  const [finalPayList, setFinalPayList] = useState([{}]);

  const downloadReport = () => {
    if (paymentList.length) {
      downloadCSV(
        getEmployeeFormattedDataOne(paymentList, 6),
        `${getCurrentDate()}_payment.csv`
      );
    } else {
      customToast.error("No data for download the report.");
    }
  };

  const finalizeRecord = () => {
    customToast.error("Please Finalize First.");
  };

  // -----------------------------------------
  return (
    <div
      className="run-payroll-section"
      style={{ backgroundColor: "transparent" }}
      onClick={hideDropdown}
    >
     <div 
  onClick={() => window.location.href = "/payroll"}
  style={{ 
    textDecoration: "none", 
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px"
  }}
  className="color-white"
>
  <ArrowBack style={{ cursor: "pointer" }} className="color-white" />
  Employee Salary
</div>
      <div className="run-payroll-body">
        {/* ---------------------------------- */}
        <div className="run-payroll-body-header">
          <div className="name-section color-white">
            {/* <PiCurrencyCircleDollar className="icon" /> */}
            <div
              style={{
                width: "30px",
                height: "30px",
                border: "1px solid lightgray",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: getInitialColor(staffName), // 🎯 Apply color
                color: "white", // Text contrast
                fontWeight: "bold",
                fontSize: "12px",
              }}
            >
              {getInitials(staffName)}
            </div>
            {getCapitalizeWord(staffName)}
          </div>

          <div className="run-payroll-body-header-content">
            <div className="center-parent">
              <div className="center-child">
                <span className="color-white">Salary Pending For</span>
                <Form>
                  <Form.Group>
                    <Form.Control
                      type="month"
                      name="selectedDate"
                      value={state.selectedDate}
                      max={maxMonth}
                      onChange={handleDate}
                      placeholder="March 2025"
                      className="universal-input-one"
                    />
                  </Form.Group>
                </Form>
              </div>

              <div className="center-child amount mt-2">
                <MdCurrencyRupee /> {payment}
              </div>

              <div className="center-child finalized mt-2">
                <div
                  onClick={() =>
                    finalize ? setSmShow(true) : handleFinalize(true)
                  }
                  style={{ cursor: "pointer" }}
                >
                  Finalized{" "}
                  {finalize ? `on ${getMonth(state.selectedDate)}` : "Now"}
                </div>
              </div>

              {HasPermission("Run Payroll", "create") && (
                <div className="center-child salary mt-3">
                  <button
                    className="universal-input-one"
                    style={{ position: "relative", width: "150px" }}
                    onClick={handleShowPaySalary}
                  >
                    <PiCurrencyCircleDollar className="icon" /> Pay Salary
                    {showSalary && (
                      <ul className="btn-drop">
                        <li>Pay Online</li>

                        <li
                          onClick={() =>
                            finalize ? setIsSaveSalary(true) : finalizeRecord()
                          }
                        >
                          Save Payment
                        </li>
                      </ul>
                    )}
                  </button>

                  <button
                    className="universal-input-one"
                    style={{ position: "relative", width: "150px" }}
                    onClick={handleShowAdvance}
                  >
                    <HiOutlineDocumentCurrencyRupee className="icon" /> Pay
                    Advance
                    {showAdvance && (
                      <ul className="btn-drop">
                        <li>Pay Online</li>

                        <li onClick={handleSavePayment}>Save Payment</li>
                      </ul>
                    )}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* ---------------------------------- */}
        <div className="run-payroll-body-content">
          <div className="body-flex">
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isWorkBasisPay")}
            >
              <TfiMenuAlt className="icon" />
              <span className="color-white">Work Basis Pay</span>
            </div>
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isIncentives")}
            >
              <LiaHandHoldingUsdSolid className="icon" />
              <span className="color-white">Incentives</span>
            </div>
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isReimbursement")}
            >
              <ReplayIcon className="icon" />
              <span className="color-white">Reimbursement</span>
            </div>
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isBonusWage")}
            >
              <IoDiamondOutline className="icon" />
              <span className="color-white">Bonus Wage</span>
            </div>
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isOvertimePay")}
            >
              <LuTimerReset className="icon" />
              <span className="color-white">Overtime Pay</span>
            </div>
          </div>
          {/* Options --------------- */}
          <div className="body-flex">
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isOtherEarning")}
            >
              <PiCurrencyCircleDollar className="icon" />
              <span className="color-white">Other Earning</span>
            </div>
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isEarlyFine")}
            >
              <RxTimer className="icon" />
              <span className="color-white">Early Fine</span>
            </div>
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isLateFine")}
            >
              <RxTimer className="icon" />
              <span className="color-white">Late Fine</span>
            </div>
            <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isDeductions")}
            >
              <CiWallet className="icon" />
              <span className="color-white">Deductions</span>
            </div>
            {/* <div
              className="content-column-flex"
              onClick={() => toggleAddDetails("isLoans")}
            >
              <CiWallet className="icon" />
              <span className="color-white">Loans</span>
            </div> */}
          </div>
        </div>

        {/* ---------------------------------- */}
      </div>
      {/* Table------------------- */}
      <div style={{ marginTop: "-80px" }}>
        <Widgets
          icon={<span className="color-white">History</span>}
          button={
            HasPermission("Run Payroll", "export") && (
              <Button
                variant="primary"
                className="universal-input-one"
                onClick={downloadReport}
              >
                Download Report
              </Button>
            )
          }
          body={
            <>
              <div
                className="ag-theme-quartz custom-grid"
                style={{
                  height: "calc(100vh - 280px)",
                  width: "100%",
                  padding: "10px 20px",
                }}
              >
                <AgGridReact
                  rowData={Array.isArray(paymentList) ? paymentList : []}
                  columnDefs={columns}
                  omLayout="autoHeight"
                  pagination={true}
                  paginationPageSize={paginationPageSize}
                  onGridReady={onGridReady}
                />
              </div>
              <div className="d-flex align-items-center justify-content-between custom-pagination px-4">
                {gridApi && <CustomPagination gridApi={gridApi} />}
              </div>
            </>
          }
        />
      </div>

      <br />
      {/* <br /> */}

      <div
        className={
          isActive
            ? isOvertimePay || isEarlyFine || isLateFine
              ? "date-hamberger active width-420"
              : "date-hamberger  active"
            : "date-hamberger"
        }
      >
        <div className="date-hamberger-header">
          <div>
            {isFirstView ? (
              <RxCross2
                className="icon color-white"
                style={{ fontSize: "15px", marginTop: "2px" }}
                onClick={toggleAddDetails}
              />
            ) : (
              <HiOutlineArrowNarrowLeft
                className="color-white"
                style={{ cursor: "pointer" }}
                onClick={() => hideSecondScreen()}
              />
            )}

            <span className="color-white" style={{ marginLeft: "10px" }}>
              {getCapitalizeWord(staffName)}
            </span>
          </div>
          {/* <span>{state.payrollMonth}</span> */}
        </div>
        {/* ----------------------------------- */}
        <div className="date-hamberger-body" style={{ zIndex: "1" }}>
          {isFirstView ? (
            <div className="mt-3">
              <div className="firstScreen">
                {!isEarlyFine && !isLateFine && (
                  <div className="header universal-input">
                    <span className="title color-white">
                      {isWorkBasisPay && "Work Basis Pay"}
                      {isIncentives && "Incentive"}
                      {isReimbursement && "Reimbursement"}
                      {isBonusWage && "BonusWage"}
                      {isOvertimePay && "Overtime Pay"}
                      {isOtherEarning && "Other Earning"}
                      {isEarlyFine && "Early Fine"}
                      {isLateFine && "Late Fine"}
                      {isDeductions && "Deductions"}
                      {isLoans && "Loans"}
                    </span>
                    <span className="amount color-white">
                      <MdCurrencyRupee />
                      <span>
                        {attendanceList.reduce(
                          (sum, item) => sum + parseFloat(item.amount),
                          0
                        )}
                      </span>
                    </span>
                  </div>
                )}

                {!isOvertimePay && !isEarlyFine
                  ? attendanceList?.map((row, idx) => {
                    return (
                      <div className="list" key={idx}>
                        <span className="date color-gray">
                          {getFormattedDate(row.paymentDate)}
                        </span>
                        <span className="amount">
                          <MdCurrencyRupee /> {row.amount}
                        </span>
                      </div>
                    );
                  })
                  : null}

                {(isWorkBasisPay ||
                  isIncentives ||
                  isReimbursement ||
                  isBonusWage ||
                  isOtherEarning ||
                  isDeductions) && (
                    <div className={"firstScreen-footer"}>
                      {HasPermission("Run Payroll", "create") && (
                        <ButtonCom
                          type={"button"}
                          class_name={"p_btn universal-btn"}
                          text={
                            isWorkBasisPay
                              ? "Add Work Basis"
                              : isIncentives
                                ? "Add Incentive"
                                : isReimbursement
                                  ? "Add Reimbursement"
                                  : isBonusWage
                                    ? "Add Bonus Wage"
                                    : isOtherEarning
                                      ? "Add Other Earning"
                                      : isDeductions
                                        ? "Add Deductions"
                                        : isLoans
                                          ? "Add Loans"
                                          : ""
                          }
                          url_or_onclick={addWorkBasisPay}
                          icon={null}
                          width={"100%"}
                        />
                      )}
                    </div>
                  )}

                {isOvertimePay && (
                  <div className="px-1">
                    <Row>
                      <Col sm="8">
                        <span>Rate</span>
                        <div className="mt-3">
                          <div className="mb-2">
                            <span>
                              &#8377; {salarySummary?.regularPay} / hours
                              Regular OT
                            </span>
                          </div>

                          <div className="mb-2">
                            <span>
                              &#8377; {salarySummary?.weekOffPay} / day Week Off
                              Pay
                            </span>
                          </div>

                          <div className="mb-2">
                            <span>
                              &#8377; {salarySummary?.holidayPay} / day Public
                              Holiday rate
                            </span>
                          </div>
                        </div>
                      </Col>
                      <Col sm="4">
                        <button
                          className="overtime-settings color-white"
                          onClick={addWorkBasisPay}
                        >
                          OVERTIME PAY SETTINGS
                        </button>
                      </Col>
                      <Col sm="12">
                        <h4 className="mb-3 mt-3">Regular Overtime</h4>
                        <div className="d-flex align-items-center justify-content-center gap-5 bg-lightgray mb-3 py-2">
                          <spa>Overtime</spa>
                          <spa>Pay For</spa>
                          <spa>Amount</spa>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-3 p-2">
                          <span>Total</span>
                          <span>
                            <MdCurrencyRupee />
                            0.00
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {isEarlyFine && (
                  <div className="mt-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Rate</span>
                      <button
                        className="overtime-settings color-white"
                        onClick={addWorkBasisPay}
                      >
                        EARLY LEAVING SETTINGS
                      </button>
                    </div>

                    <Row>
                      <Col sm="12">
                        <div className="mt-3">
                          <div className="mb-2">
                            <span>
                              &#8377; {salarySummary?.allowedEarlyDays} / day
                              Allowed Early Days
                            </span>
                          </div>

                          <div className="mb-2">
                            <span>
                              {salarySummary?.deductionType == "1"
                                ? "Day Wise"
                                : "Hour Wise"}
                            </span>
                          </div>

                          <div className="mb-2">
                            <span>
                              &#8377; {salarySummary?.deductionRate} / day rate
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="d-flex align-items-center justify-content-center gap-3 mt-5 bg-lightgray mb-3 py-2">
                      <span className="font-size-12">Early Hours</span>
                      <span className="font-size-12">
                        Deduct fine for the day
                      </span>
                      <span className="font-size-12">Amount</span>
                    </div>

                    <div className="d-flex align-items-center justify-content-between mb-3  p-2">
                      <span>Total</span>
                      <span>
                        <MdCurrencyRupee />
                        0.00
                      </span>
                    </div>
                  </div>
                )}

                {isLateFine && (
                  <div className="mt-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <span>Rate</span>
                      <button
                        className="overtime-settings color-white"
                        onClick={addWorkBasisPay}
                      >
                        LATE LEAVING SETTINGS
                      </button>
                    </div>

                    <Row>
                      <Col sm="12">
                        <div className="mt-3">
                          <div className="mb-2">
                            <span>
                              &#8377; {salarySummary?.allowedLateDays} / day
                              Allowed Late Days
                            </span>
                          </div>

                          <div className="mb-2">
                            <span>
                              {salarySummary?.deductionType == "1"
                                ? "Day Wise"
                                : "Hour Wise"}
                            </span>
                          </div>

                          <div className="mb-2">
                            <span>
                              &#8377; {salarySummary?.deductionRate} / day rate
                            </span>
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="d-flex align-items-center justify-content-center gap-3 mt-5 mb-3 py-2 bg-lightgray">
                      <span className="font-size-12">Early Hours</span>
                      <span className="font-size-12">
                        Deduct fine for the day
                      </span>
                      <span className="font-size-12">Amount</span>
                    </div>

                    <div className="d-flex align-items-center justify-content-between mb-3  p-2">
                      <span>Total</span>
                      <span>
                        <MdCurrencyRupee />
                        0.00
                      </span>
                    </div>
                  </div>
                )}
              </div>

              {/* ----------------------------------------- */}
            </div>
          ) : (
            <div>
              {!isOvertimePay && !isEarlyFine && !isLateFine && !isLoans ? (
                <div className="mt-3">
                  <div className="firstScreen">
                    <div className="header universal-input">
                      <span className="title">
                        {isWorkBasisPay && "Add Work Basis Pay"}
                        {isIncentives && "Add Incentive"}
                        {isReimbursement && "Add Reimbursement"}
                        {isBonusWage && "Add Bonus Wage"}
                        {isOvertimePay && "Add Overtime Pay"}
                        {isOtherEarning && "Add Other Earning"}
                        {isEarlyFine && "Add Early Fine"}
                        {isLateFine && "Add Late Fine"}
                        {isDeductions && "Add Deductions"}
                        {isLoans && "Add Loans"}
                      </span>
                    </div>
                    <Form
                      noValidate
                      validated={workBasisValidated}
                      onSubmit={handleSubmit}
                    >
                      <Form.Group className="mt-3">
                        {isIncentives && (
                          <Form.Group
                            className="mb-3"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "10px",
                            }}
                            controlId="type"
                          >
                            <Form.Label
                              style={{ textWrap: "nowrap", fontSize: "14px" }}
                            >
                              Type
                            </Form.Label>
                            <div>
                              <Form.Select
                                style={{ width: "200px" }}
                                name="type"
                                aria-label="Type"
                                aria-describedby="basic-addon1"
                                required
                                className="universal-input-one"
                              >
                                <option>Select incentive type</option>
                                <option value="Incentive 1">Incentive 1</option>
                                <option value="Incentive 2">Incentive 2</option>
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Type required.
                              </Form.Control.Feedback>
                            </div>
                          </Form.Group>
                        )}

                        <Form.Group
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "10px",
                          }}
                          controlId="amount"
                        >
                          <Form.Label
                            style={{ textWrap: "nowrap", fontSize: "14px" }}
                          >
                            {isWorkBasisPay && "Rate Per Unit"}
                            {isIncentives && "Amount"}
                            {isReimbursement && "Amount"}
                            {isBonusWage && "Amount"}
                            {isOvertimePay && "Amount"}
                            {isOtherEarning && "Amount"}
                            {isEarlyFine && "Amount"}
                            {isLateFine && "Amount"}
                            {isDeductions && "Amount"}
                            {isLoans && "Amount"}
                          </Form.Label>
                          <InputGroup style={{ width: "200px" }} hasValidation>
                            <InputGroup.Text
                              id="basic-addon1"
                              className="universal-input-one"
                            >
                              ₹
                            </InputGroup.Text>
                            <Form.Control
                              name="amount"
                              placeholder="Enter Amount"
                              aria-label="Unit"
                              aria-describedby="basic-addon1"
                              required
                              className="universal-input-one"
                            />
                            <Form.Control.Feedback type="invalid">
                              Amount required.
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>

                        {/* <Form.Group
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "10px",
                          }}
                          controlId="quantity"
                        >
                          <Form.Label
                            style={{ textWrap: "nowrap", fontSize: "14px" }}
                          >
                            Quantity
                          </Form.Label>
                          <Form.Control
                            style={{ width: "200px" }}
                            placeholder="Enter quantity"
                            aria-label="Quantity"
                            aria-describedby="basic-addon1"
                          />
                        </Form.Group> */}

                        <Form.Group
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "10px",
                          }}
                          controlId="paymentDate"
                        >
                          <Form.Label
                            style={{ textWrap: "nowrap", fontSize: "14px" }}
                          >
                            Payment Date
                          </Form.Label>
                          <div>
                            <Form.Control
                              style={{ width: "200px" }}
                              type="date"
                              name="paymentDate"
                              format="yyyy-mm-dd"
                              aria-label="Payment Date"
                              aria-describedby="basic-addon1"
                              max={today}
                              required
                              className="universal-input-one"
                            />
                            <Form.Control.Feedback type="invalid">
                              Payment Date required.
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>

                        <Form.Group
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "10px",
                          }}
                          controlId="notes"
                        >
                          <Form.Label
                            style={{ textWrap: "nowrap", fontSize: "14px" }}
                          >
                            Notes
                          </Form.Label>
                          <div>
                            <Form.Control
                              name="notes"
                              style={{ width: "200px", height: "100px" }}
                              placeholder="Enter notes"
                              as="textarea"
                              aria-label="With textarea"
                              aria-describedby="basic-addon1"
                              required
                              className="universal-input-one"
                            />
                            <Form.Control.Feedback type="invalid">
                              Notes required.
                            </Form.Control.Feedback>
                          </div>
                        </Form.Group>
                      </Form.Group>

                      <Form.Group className="firstScreen-footer">
                        <Button
                          type="button"
                          style={{
                            border: "1px solid gray",
                            backgroundColor: "gray",
                            color: "#fff",
                            width: "150px",
                            height: "30px",
                            lineHeight: "10px",
                          }}
                          onClick={hideSecondScreen}
                        >
                          Cancel
                        </Button>
                        {HasPermission("Run Payroll", "create") && (
                          <Button
                            type="submit"
                            className="universal-btn"
                            style={{
                              width: "350px",
                            }}
                          >
                            {isWorkBasisPay && "Save Work Basis"}
                            {isIncentives && "Save Incentive"}
                            {isReimbursement && "Save Reimbursement"}
                            {isBonusWage && "Save BonusWage"}
                            {isOvertimePay && "Save Overtime Pay"}
                            {isOtherEarning && "Save Other Earning"}
                            {isEarlyFine && "Save Early Fine"}
                            {isLateFine && "Save Late Fine"}
                            {isDeductions && "Save Deductions"}
                            {isLoans && "Save Loans"}
                          </Button>
                        )}
                      </Form.Group>
                    </Form>
                  </div>
                </div>
              ) : (
                <div className="mt-3">
                  {isOvertimePay && (
                    <div>
                      <h4 className="mt-3 mb-3">Overtime Pay Settings</h4>

                      <Form
                        noValidate
                        validated={workBasisValidated}
                        onSubmit={saveDifferentTypeData}
                      >
                        <span className="mt-3 mb-3">Enter Day OT</span>
                        <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
                          <span className="color-gray">WeekOff Pay</span>
                          <Form.Group>
                            <Form.Control
                              name="weekOffPay"
                              aria-label="Type"
                              aria-describedby="basic-addon1"
                              className="universal-input-one"
                              placeholder="&#8377; 0"
                            />
                          </Form.Group>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <span className="color-gray">Public Holiday Pay</span>
                          <Form.Group>
                            <Form.Control
                              name="holidayPay"
                              className="universal-input-one"
                              placeholder="&#8377; 0"
                            />
                          </Form.Group>
                        </div>
                        {/* ------------------------------------- */}
                        <span className="mt-3 mb-3">Enter Hours OT</span>
                        <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
                          <span className="color-gray">Enter Hours Pay</span>
                          <Form.Group>
                            <Form.Control
                              name="regularPay"
                              className="universal-input-one"
                              placeholder="&#8377; 0"
                            />
                          </Form.Group>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-3 position-relative">
                          <span className="color-gray">Grace Period</span>

                          <InputGroup style={{ width: "238px" }} hasValidation>
                            <Form.Control
                              name="gracePeriod"
                              className="universal-input-one"
                              placeholder="0"
                            />
                            <InputGroup.Text
                              id="basic-addon1"
                              className="universal-input-one"
                            >
                              minutes
                            </InputGroup.Text>
                          </InputGroup>
                        </div>

                        <Form.Group className="firstScreen-footer d-flex align-items-center justify-content-center gap-3 mt-5">
                          <Button
                            type="button"
                            style={{
                              border: "1px solid gray",
                              backgroundColor: "gray",
                              color: "#fff",
                              width: "150px",
                              height: "30px",
                              lineHeight: "10px"
                            }}
                            onClick={hideSecondScreen}
                          >
                            Cancel
                          </Button>
                          {HasPermission("Run Payroll", "create") && (
                            <Button
                              type="submit"
                              className="universal-btn gap-2"
                              style={{
                                width: "350px",
                              }}
                            >
                              {isWorkBasisPay && "Save Work Basis"}
                              {isIncentives && "Save Incentive"}
                              {isReimbursement && "Save Reimbursement"}
                              {isBonusWage && "Save BonusWage"}
                              {isOvertimePay && "Save"}
                              {isOtherEarning && "Save Other Earning"}
                              {isEarlyFine && "Save Early Fine"}
                              {isLateFine && "Save Late Fine"}
                              {isDeductions && "Save Deductions"}
                              {isLoans && "Save Loans"}
                            </Button>
                          )}
                        </Form.Group>
                      </Form>
                    </div>
                  )}

                  {isEarlyFine && (
                    <div>
                      <h4 className="mt-3 mb-3">Early Leaving Settings</h4>

                      <Form
                        noValidate
                        validated={workBasisValidated}
                        onSubmit={saveDifferentTypeData}
                      >
                        <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
                          <span className="color-gray">Allowed Early Days</span>

                          <InputGroup style={{ width: "238px" }} hasValidation>
                            <Form.Control
                              name="allowedEarlyDays"
                              className="universal-input-one"
                              placeholder="0"
                            />
                            <InputGroup.Text
                              id="basic-addon1"
                              className="universal-input-one"
                            >
                              days
                            </InputGroup.Text>
                          </InputGroup>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <span className="color-gray">Grace Period</span>

                          <InputGroup style={{ width: "238px" }} hasValidation>
                            <Form.Control
                              name="gracePeriod"
                              className="universal-input-one"
                              placeholder="0"
                            />
                            <InputGroup.Text
                              id="basic-addon1"
                              className="universal-input-one"
                            >
                              minutes
                            </InputGroup.Text>
                          </InputGroup>
                        </div>
                        {/* ------------------------------------- */}
                        <Form.Group>
                          <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
                            <span className="color-gray">Deduction Type</span>
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <Form.Check
                                type="radio"
                                name="deductionType"
                                value="1"
                                label="Day wise"
                                checked
                                className="font-size-12"
                              />
                              <Form.Check
                                type="radio"
                                name="deductionType"
                                value="2"
                                label="Hour wise"
                                className="font-size-12"
                              />
                            </div>
                          </div>
                        </Form.Group>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <span className="color-gray">Deduction Rate</span>

                          <InputGroup style={{ width: "238px" }} hasValidation>
                            <Form.Control
                              name="deductionRate"
                              className="universal-input-one"
                              placeholder="&#8377; 0"
                            />
                            <InputGroup.Text
                              id="basic-addon1"
                              className="universal-input-one"
                            >
                              / day
                            </InputGroup.Text>
                          </InputGroup>
                        </div>
                        <Form.Group className="firstScreen-footer d-flex align-items-center justify-content-center gap-3 mt-5">
                          <Button
                            type="button"
                            style={{
                              border: "1px solid gray",
                              backgroundColor: "gray",
                              color: "#fff",
                              width: "150px",
                              height: "30px",
                              lineHeight: "10px"
                            }}
                            onClick={hideSecondScreen}
                          >
                            Cancel
                          </Button>
                          {HasPermission("Run Payroll", "create") && (
                            <Button
                              type="submit"
                              className="universal-btn gap-2"
                              style={{
                                width: "350px",
                              }}
                            >
                              {isWorkBasisPay && "Save Work Basis"}
                              {isIncentives && "Save Incentive"}
                              {isReimbursement && "Save Reimbursement"}
                              {isBonusWage && "Save BonusWage"}
                              {isOvertimePay && "Save"}
                              {isOtherEarning && "Save Other Earning"}
                              {isEarlyFine && "Save Early Fine"}
                              {isLateFine && "Save Late Fine"}
                              {isDeductions && "Save Deductions"}
                              {isLoans && "Save Loans"}
                            </Button>
                          )}
                        </Form.Group>
                      </Form>
                    </div>
                  )}

                  {isLateFine && (
                    <div>
                      <h4 className="mt-3 mb-3">Late Coming Settings</h4>

                      <Form
                        noValidate
                        validated={workBasisValidated}
                        onSubmit={saveDifferentTypeData}
                      >
                        <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
                          <span className="color-gray">Allowed Late Days</span>
                          <InputGroup style={{ width: "238px" }} hasValidation>
                            <Form.Control
                              name="allowedLateDays"
                              className="universal-input-one"
                              placeholder="0"
                            />
                            <InputGroup.Text
                              id="basic-addon1"
                              className="universal-input-one"
                            >
                              days
                            </InputGroup.Text>
                          </InputGroup>
                        </div>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <span className="color-gray">Grace Period</span>
                          <InputGroup style={{ width: "238px" }} hasValidation>
                            <Form.Control
                              name="gracePeriod"
                              className="universal-input-one"
                              placeholder="0"
                            />
                            <InputGroup.Text
                              id="basic-addon1"
                              className="universal-input-one"
                            >
                              minutes
                            </InputGroup.Text>
                          </InputGroup>
                        </div>
                        {/* ------------------------------------- */}
                        <Form.Group>
                          <div className="d-flex align-items-center justify-content-between mt-3 mb-3">
                            <span className="color-gray">Deduction Type</span>
                            <div className="d-flex align-items-center justify-content-between gap-2">
                              <Form.Check
                                type="radio"
                                name="deductionType"
                                label="Day wise"
                                className="font-size-12"
                                value={"1"}
                                checked
                              />
                              <Form.Check
                                type="radio"
                                name="deductionType"
                                label="Hour wise"
                                className="font-size-12"
                                value={"2"}
                              />
                            </div>
                          </div>
                        </Form.Group>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <span className="color-gray">Deduction Rate</span>
                          <InputGroup style={{ width: "238px" }} hasValidation>
                            <Form.Control
                              name="deductionRate"
                              className="universal-input-one"
                              placeholder="0"
                            />
                            <InputGroup.Text
                              id="basic-addon1"
                              className="universal-input-one"
                            >
                              / day
                            </InputGroup.Text>
                          </InputGroup>
                        </div>
                        <Form.Group className="firstScreen-footer d-flex align-items-center justify-content-center gap-3 mt-5">
                          <Button
                            type="button"
                            style={{
                              border: "1px solid gray",
                              backgroundColor: "gray",
                              color: "#fff",
                              width: "150px",
                              height: "30px",
                              lineHeight: "10px"
                            }}
                            onClick={hideSecondScreen}
                          >
                            Cancel
                          </Button>
                          {HasPermission("Run Payroll", "create") && (
                            <Button
                              type="submit"
                              className="universal-btn gap-2"
                              style={{
                                width: "350px",
                              }}
                            >
                              Save
                            </Button>
                          )}
                        </Form.Group>
                      </Form>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {/* ------------------------------------- */}
      <div
        className={isSavePayment ? "date-hamberger active" : "date-hamberger"}
      >
        <div
          className="date-hamberger-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <RxCross2
              className="icon color-white"
              style={{ fontSize: "15px", marginTop: "2px" }}
              onClick={handleSavePayment}
            />

            <span className="color-white" style={{ marginLeft: "10px" }}>
              {getCapitalizeWord(staffName)}
            </span>
          </div>
          <span className=" color-white">{state.selectedDate}</span>
        </div>

        <div className="date-hamberger-body" style={{ zIndex: "1" }}>
          <div className="mt-3">
            <div className="firstScreen">
              <div className="header universal-input">
                <span className="title color-white">Add Advance</span>
              </div>
            </div>

            <div>
              <div className="firstScreen">
                <Form
                  noValidate
                  validated={workBasisValidated}
                  onSubmit={submitAdvance}
                >
                  <Form.Group className="mt-3">
                    <Form.Group
                      className="mb-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                      controlId="amount"
                    >
                      <Form.Label
                        style={{ textWrap: "nowrap", fontSize: "14px" }}
                      >
                        Amount
                      </Form.Label>
                      <InputGroup style={{ width: "200px" }} hasValidation>
                        <InputGroup.Text
                          id="basic-addon1"
                          className="universal-input-one"
                        >
                          ₹
                        </InputGroup.Text>
                        <Form.Control
                          name="amount"
                          placeholder="Enter Amount"
                          aria-label="Unit"
                          aria-describedby="basic-addon1"
                          required
                          className="universal-input-one"
                        />
                        <Form.Control.Feedback type="invalid">
                          Amount required.
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group
                      className="mb-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                      controlId="paymentDate"
                    >
                      <Form.Label
                        style={{ textWrap: "nowrap", fontSize: "14px" }}
                      >
                        Payment Date
                      </Form.Label>
                      <div>
                        <Form.Control
                          style={{ width: "200px" }}
                          type="date"
                          name="paymentDate"
                          format="yyyy-mm-dd"
                          aria-label="Payment Date"
                          aria-describedby="basic-addon1"
                          max={today}
                          required
                          className="universal-input-one"
                        />
                        <Form.Control.Feedback type="invalid">
                          Payment Date required.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>

                    <Form.Group
                      className="mb-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                      controlId="notes"
                    >
                      <Form.Label
                        style={{ textWrap: "nowrap", fontSize: "14px" }}
                      >
                        Notes
                      </Form.Label>
                      <div>
                        <Form.Control
                          name="notes"
                          style={{ width: "200px", height: "100px" }}
                          placeholder="Enter notes"
                          as="textarea"
                          aria-label="With textarea"
                          aria-describedby="basic-addon1"
                          required
                          className="universal-input-one"
                        />
                        <Form.Control.Feedback type="invalid">
                          Notes required.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>
                  </Form.Group>

                  {isSavePayment && (
                    <Form.Group className="firstScreen-footer">
                      <Button
                        type="button"
                        style={{
                          border: "1px solid gray",
                          backgroundColor: "gray",
                          color: "#fff",
                          width: "150px",
                          lineHeight: "10px",
                          height: "30px"
                        }}
                        onClick={handleSavePayment}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="universal-btn"
                        style={{
                          width: "250px",
                        }}
                      >
                        Save Payment
                      </Button>
                    </Form.Group>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ------------------------------------- */}
      <div
        className={isSaveSalary ? "date-hamberger active" : "date-hamberger"}
      >
        <div
          className="date-hamberger-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <RxCross2
              className="icon color-white"
              style={{ fontSize: "15px", marginTop: "2px" }}
              onClick={() => setIsSaveSalary(false)}
            />

            <span className="color-white" style={{ marginLeft: "10px" }}>
              {getCapitalizeWord(staffName)}
            </span>
          </div>
          <span className="color-white">{state.selectedDate}</span>
        </div>

        <div className="date-hamberger-body" style={{ zIndex: "1" }}>
          <div className="mt-3">
            <div className="firstScreen">
              <div className="header universal-input">
                <span className="title color-white">Add Payment</span>
              </div>
            </div>

            <div>
              <div className="firstScreen">
                <Form
                  noValidate
                  validated={workBasisValidated}
                  onSubmit={submitSalary}
                >
                  <Form.Group className="mt-3">
                    <Form.Group
                      className="mb-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                      controlId="amount"
                    >
                      <Form.Label
                        style={{ textWrap: "nowrap", fontSize: "14px" }}
                      >
                        Amount
                      </Form.Label>
                      <InputGroup style={{ width: "200px" }} hasValidation>
                        <InputGroup.Text
                          id="basic-addon1"
                          className="universal-input-one"
                        >
                          ₹
                        </InputGroup.Text>
                        <Form.Control
                          name="amount"
                          placeholder="Enter Amount"
                          aria-label="Unit"
                          aria-describedby="basic-addon1"
                          required
                          className="universal-input-one"
                        />
                        <Form.Control.Feedback type="invalid">
                          Amount required.
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>

                    <Form.Group
                      className="mb-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                      controlId="paymentDate"
                    >
                      <Form.Label
                        style={{ textWrap: "nowrap", fontSize: "14px" }}
                      >
                        Payment Date
                      </Form.Label>
                      <div>
                        <Form.Control
                          style={{ width: "200px" }}
                          type="date"
                          name="paymentDate"
                          format="yyyy-mm-dd"
                          aria-label="Payment Date"
                          aria-describedby="basic-addon1"
                          max={today}
                          required
                          className="universal-input-one"
                        />
                        <Form.Control.Feedback type="invalid">
                          Payment Date required.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group>

                    {/* <Form.Group
                      className="mb-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                      controlId="notes"
                    >
                      <Form.Label
                        style={{ textWrap: "nowrap", fontSize: "14px" }}
                      >
                        Notes
                      </Form.Label>
                      <div>
                        <Form.Control
                          name="notes"
                          style={{ width: "200px", height: "100px" }}
                          placeholder="Enter notes"
                          as="textarea"
                          aria-label="With textarea"
                          aria-describedby="basic-addon1"
                          required
                          className="universal-input-one"
                        />
                        <Form.Control.Feedback type="invalid">
                          Notes required.
                        </Form.Control.Feedback>
                      </div>
                    </Form.Group> */}
                  </Form.Group>

                  {isSaveSalary && (
                    <Form.Group className="firstScreen-footer">
                      <Button
                        type="button"
                        style={{
                          border: "1px solid gray",
                          backgroundColor: "gray",
                          color: "#fff",
                          width: "150px",
                          height: "30px",
                          lineHeight: "10px"
                        }}
                        onClick={() => setIsSaveSalary(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="universal-btn"
                        style={{
                          width: "250px",
                        }}
                      >
                        Save Payment
                      </Button>
                    </Form.Group>
                  )}
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ------------------------------------- */}

      <div
        className={
          isFinalizePayroll
            ? "extra-size-slider-popup active"
            : "extra-size-slider-popup"
        }
      >
        <div className="d-flex align-items-center justify-content-start gap-2 py-2 ">
          <RxCross2
            className="icon color-white"
            style={{
              cursor: "pointer",
              fontSize: "15px",
              marginTop: "2px",
            }}
            onClick={() => setIsFinalizePayroll(false)}
          />
          <span className="color-white" style={{ marginLeft: "10px" }}>
            {getCapitalizeWord(staffName)}
          </span>
        </div>

        <div>
          <div className="d-flex align-items-center justify-content-between header mt-4">
            <div className="right-contents">
              <div className="mb-3">
                <span>Payroll Month : </span>
                <span className="fill-background">
                  {" "}
                  {staffDetails[0]?.empStaffDetails?.payrollMonthYear}
                </span>
              </div>
              {/* <div className="mb-3">
                <span>Days in Attendance Cycle : </span>
                <span className="fill-background">
                  {staffDetails[0]?.empStaffDetails?.payrollMonthYear}
                </span>
              </div> */}
              <div className="mb-3">
                <span>Period Type : </span>
                <span className="fill-background">
                  {staffDetails[0]?.empStaffDetails?.payrollType}
                </span>
              </div>

              <div className="mb-3">
                <span>Cycle Type : </span>
                <span className="fill-background">
                  {staffDetails[0]?.salaryCountDays?.cycleTypeValue}
                </span>
              </div>
            </div>
          </div>

          <div className="mt-3">
            <h4 className="mb-3">Verify Attendance</h4>

            <div
              className="ag-theme-quartz custom-grid"
              style={{
                height: "calc(100vh - 388px)",
                width: "100%",
                padding: "10px 20px",
              }}
            >
              <AgGridReact
                rowData={Array.isArray(staffDetails) ? staffDetails : []}
                columnDefs={finalPayColumns}
                omLayout="autoHeight"
              // pagination={true}
              //  onGridReady={onGridReady}
              />
            </div>

            <div
              className="d-flex align-items-center justify-content-end mt-3 mb-4"
              style={{ paddingRight: "20px" }}
            >
              {HasPermission("Run Payroll", "edit") && (
                <button className="universal-btn" onClick={saveFinalize}>
                  Verify Salary
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ------------------------------------- */}
      <div className={isActiveCtc ? "date-hamberger active" : "date-hamberger"}>
        <div className="date-hamberger-header">
          <div>
            <RxCross2
              className="icon color-white border-gray"
              style={{ fontSize: "15px", marginTop: "2px" }}
              onClick={() => setIsActiveCtc(false)}
            />

            <span className="color-white" style={{ marginLeft: "10px" }}>
              {getCapitalizeWord(staffName)}
            </span>
          </div>
          {/* <span>{state.payrollMonth}</span> */}
        </div>

        <div className="date-hamberger-body">
          {Object.keys(addCtc).length > 0 ? (
            <div className="ctc-content">
              <div className="ctc-content-title universal-input-one">
                <span className="color-white">Gross Amount</span>
                <span className="color-white">
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.grossSalary : 0}
                </span>
              </div>

              <div className="ctc-content-title mt-3 universal-input-one">
                <span className="color-white">Earnings</span>
              </div>
              {/* ------------------------------------------ */}
              <div className="ctc-content-subtitle">
                <span className="color-gray">BASIC</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.basicPay : 0}
                </span>
              </div>
              {addAllowance?.length > 0 &&
                //  row.name != "Dearness Allowance"
                addAllowance
                  .filter((row, idx) => row.name == "Dearness Allowance")
                  .map((row, idx) => {
                    return (
                      <div className="ctc-content-subtitle" key={idx}>
                        <span className="color-gray">{row.name}</span>
                        <span>
                          <LiaRupeeSignSolid /> {row.monthlyAmount}
                        </span>
                      </div>
                    );
                  })}

              <div className="ctc-content-subtitle">
                <span className="color-gray">HRA</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.hraPay : 0}
                </span>
              </div>

              {addAllowance?.length > 0 &&
                //  row.name != "Dearness Allowance"
                addAllowance
                  .filter((row, idx) => row.name != "Dearness Allowance")
                  .map((row, idx) => {
                    return (
                      <div className="ctc-content-subtitle" key={idx}>
                        <span className="color-gray">{row.name}</span>
                        <span>
                          <LiaRupeeSignSolid /> {row.monthlyAmount}
                        </span>
                      </div>
                    );
                  })}

              <div className="ctc-content-subtitle">
                <span className="color-gray">Other Allowance</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.otherAllowance : 0}
                </span>
              </div>

              {/* ============================ */}
              <div className="ctc-content-title mt-3 universal-input-one">
                <span className="color-white">Employer Contribution</span>
              </div>
              {/* ------------------------------------------ */}
              <div className="ctc-content-subtitle">
                <span className="color-gray">Employer PF</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.employerPf : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span className="color-gray">Employer ESI</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.employerEsi : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span className="color-gray">Employer LWF</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.employer_lwf : 0}
                </span>
              </div>
              <div className="ctc-content-subtitle">
                <span className="color-gray">PF EDLI & Admin Charges</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0
                    ? parseFloat(addCtc.adminCharges) +
                    parseFloat(addCtc.edliCharges)
                    : 0}
                </span>
              </div>

              {addNewAllowance?.length > 0 &&
                addNewAllowance.map((row, idx) => {
                  return (
                    <div className="ctc-content-subtitle" key={idx}>
                      <span className="color-gray">{row.name}</span>
                      <span>
                        <LiaRupeeSignSolid /> {row.monthlyAmount}
                      </span>
                    </div>
                  );
                })}

              {/* ============================ */}
              <div className="ctc-content-title mt-3 universal-input-one">
                <span className="color-white">Deductions</span>
              </div>
              {/* ------------------------------------------ */}
              {/* <div className="ctc-content-subtitle">
                <span>Insurance</span>
                <span>
                  <LiaRupeeSignSolid /> 750
                </span>
              </div> */}

              <div className="ctc-content-subtitle">
                <span className="color-gray">Employee PF</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.employeePf : 0}
                  {Object.keys(addCtc).length > 0
                    ? addCtc.totalEmployeePF == "1800"
                      ? "LIMIT"
                      : ""
                    : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span className="color-gray">Employee ESI</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.employeeEsi : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span className="color-gray">Employee LWF</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0 ? addCtc.employee_lwf : 0}
                </span>
              </div>

              <div className="ctc-content-subtitle">
                <span className="color-gray">Professional Tax</span>
                <span>
                  <LiaRupeeSignSolid />
                  {Object.keys(addCtc).length > 0
                    ? addCtc.professionalTax != ""
                      ? addCtc.professionalTax
                      : "0"
                    : 0}
                </span>
              </div>
            </div>
          ) : (
            "No Data"
            // <div className="ctc_not_added">
            //   <span style={{ textWrap: "nowrap", marginRight: "60px" }}>
            //     CTC not added
            //   </span>
            //   <ButtonCom
            //     type="button"
            //     class_name={"p_btn universal-input"}
            //     text={"+ Add CTC"}
            //     url_or_onclick={onClick={() => setIsActiveCtc(false)}}
            //     icon={null}
            //     width={""}
            //   />
            // </div>
          )}
        </div>
        {/* 
              <div className="date-hamberger-fooer">
                <button
                  type="button"
                  style={{
                    backgroundColor: "#fff",
                    color: "#000",
                    border: "1px solid gray",
                    borderRadius: "5px",
                    width: "200px",
                    height: "35px",
                  }}
                  onClick={toggleAddCtc}
                >
                  Cancel
                </button>
      
                <button
                  type="button"
                  style={{
                    backgroundColor: "blue",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    width: "200px",
                    height: "35px",
                  }}
                  // onClick={handelSaveIncentiveStaff}
                >
                  Save
                </button>
              </div> */}
      </div>
      {/* ------------------------------------- */}
      <Modal
        size="sm"
        show={smShow}
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
        className="custom-modal"
      >
        <Modal.Header closeButton className="custom-modal-body">
          <Modal.Title id="example-modal-sizes-title-sm">Finalize</Modal.Title>
        </Modal.Header>
        <Modal.Body className="custom-modal-body">
          <h5>Do you want to unfinalize</h5>
        </Modal.Body>
        <Modal.Footer className="custom-modal-body">
          <Button className="universal-btn" onClick={saveUnFinalize}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

   
    </div>
  );
};

export default RunPayroll;
